export const checkboxClasses = [
  'peer size-4 shrink-0 rounded-sm border border-input shadow-xs transition-shadow outline-none',
  'bg-background text-foreground dark:bg-input/30',
  'data-[state=checked]:bg-teal-600 data-[state=checked]:text-white data-[state=checked]:border-teal-600',
  'focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:border-ring',
  'aria-invalid:border-red-500 aria-invalid:ring-red-500/20 dark:aria-invalid:ring-red-500/40',
  'disabled:cursor-not-allowed disabled:opacity-50',
].join(' ');

export const checkboxIndicatorClasses =
  'flex items-center justify-center text-current transition-none';

export const checkboxReadOnlyClasses = 'cursor-default opacity-100';
